import React from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GroupIcon from '@mui/icons-material/Group';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useNavigate } from 'react-router-dom';


export default function VagaCard({ vaga }) {
  function daysSince(isoDate) {
    if (!isoDate) return null;
    const msPerDay = 24 * 60 * 60 * 1000;
    const created = new Date(isoDate).getTime();
    const now = Date.now();
    return Math.floor((now - created) / msPerDay);
  }

  const navigate = useNavigate();

  const redirect = () => {
    navigate(`/vaga/${vaga.cod_vaga}`);
  };

  return (
    <Box sx={{ width: '100%' }} className="card" onClick={redirect} style={{ cursor: 'pointer', minHeight: "-webkit-fill-available" }}>
      <div className="card-body row">
        <Typography className="reconect-text" style={{ fontSize: "large", marginTop: 0, paddingTop: 0 }}>{vaga.titulo}</Typography>
      </div>
      <div className="card-body row" style={{ textAlign: "center" }}>
        <Typography gutterBottom sx={{ display: 'block' }} style={{ float: "left", marginBottom: 0 }}>
          <LocationOnIcon color="error" /> {`${vaga.bairro} - ${vaga.cidade}`}
        </Typography>
      </div>
      <div className="card-body">
        <Typography variant="caption" gutterBottom sx={{ display: 'block' }} style={{ float: "left", marginBottom: 0 }}>
          <GroupIcon color="primary"  /> {vaga.quantidade_vagas}
        </Typography>
        <Typography variant="caption" gutterBottom sx={{ display: 'block' }} style={{ float: "right", marginBottom: 0 }}>
          <AccessTimeIcon color="warning"  /> Publicado há {daysSince(vaga.criado_em)} dias
        </Typography>
      </div>
    </Box>
  );
}
